import React, { useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import { Breadcrumbs } from '@cokitchen/cokitchen-components';
import { useLocation } from 'react-router-dom';
import useEditShopContext from 'contexts/shop.context';
import EditShopImages from './edit-shop-images';
import PreviewShopImages from './preview-shop-images';

const ShopImages = () => {
  const { shopDetails, loadingShop } = useEditShopContext();

  const [editing, setEditing] = useState(
    new URLSearchParams(useLocation().search).get('edit') === 'true'
  );

  const shopName = shopDetails.name;
  const breadcrumbs = [
    { name: 'Overview', path: `${ROUTE_PREFIX.SHOP}/${ROUTE_KEYS.OVERVIEW}` },

    {
      name: `${shopName}`,
      path: ''
    }
  ];

  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <PageHeaderText
        title={shopName ?? 'Shop'}
        description={`Update ${shopName ?? 'Shop'} details here`}>
        {!editing && (
          <button
            className='border border-[#E7E8E9] shadow text-[#5C5F64] w-[86px] h-[40px] py-2 rounded-[8px]'
            onClick={() => {
              setEditing(true);
            }}>
            Edit
          </button>
        )}
      </PageHeaderText>
      {loadingShop ? (
        <div className='animate-bounce mt-28 grid place-items-center font-medium text-red-5'>
          Loading...
        </div>
      ) : (
        <>
          {editing ? (
            <EditShopImages onEditComplete={() => setEditing(false)} />
          ) : (
            <PreviewShopImages />
          )}
        </>
      )}
    </div>
  );
};

export default ShopImages;
